export default __webpack_public_path__ + "static/media/m3-2.dc1ddf06.png";